// removed by extract-text-webpack-plugin
module.exports = {"formatList":"NumberRange__formatList___2Lyxj","button":"NumberRange__button___3gIsN","buttonDisable":"NumberRange__buttonDisable___1cBRt","statusIcon":"NumberRange__statusIcon___LhdyK","historyBody":"NumberRange__historyBody___33skb"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/NumberRange/components/NumberRange.scss
// module id = 1215
// module chunks = 1